let appConfig = require('../../config/index.js')

const ALL_API = {
  // 获取会员余额流水
  listMemberBalance: {
    method: 'get',
    url: '/api/wechat/listMemberBalance'
  },
  // 获取会员余额流水详情
  infoMemberBalance: {
    method: 'get',
    url: '/api/wechat/infoMemberBalance'
  },
  // 微信支付
  weChatCreatRechargeOrder: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/market/order/weChatCreatRechargeOrder',
  },
  //获取用户已购买的服务商品和套餐 购买使用详情
  blanchPayment: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/market/order/payment'
  },
  //获取用户已购买的服务商品和套餐 购买使用详情
  weChatPayment: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/market/order/weChatPayment'
  },
  // 积分加钱兑换 - 创建订单
  createScoreExchangeOrder: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/market/order/createScoreExchangeOrder'
  },
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/spareMoney/index.js